import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Skeleton } from '@mui/material';
export const Action = ({ name, icon, action, enable = true, loaded = true }) => {
    return (_jsxs("div", { style: { display: 'grid' }, children: [_jsx(Button, { variant: 'contained', disabled: !enable, onClick: () => action(), startIcon: icon, sx: {
                    gridRowStart: 1,
                    gridColumnStart: 1,
                    visibility: !loaded ? 'hidden' : undefined,
                }, children: name }), !loaded && _jsx(Skeleton, { variant: "rounded", height: '100%', width: '100%', sx: { gridRowStart: 1, gridColumnStart: 1 } })] }));
};
